import { useQuery } from '@tanstack/vue-query';
import AdyenPlugin from '@/capacitor-plugins/AdyenPlugin';
import { Capacitor } from '@capacitor/core';
import { computed, onMounted, ref } from 'vue';

let adyenPosSessionInit: Promise<boolean> | null = null;

export function ensureAdyenPosSession(): Promise<boolean> {
  if (!Capacitor.isPluginAvailable('Adyen')) {
    return Promise.resolve(false);
  }

  if (adyenPosSessionInit) {
    return adyenPosSessionInit;
  }

  adyenPosSessionInit = (async () => {
    try {
      const { needsTapToPayLinking } = await AdyenPlugin.needsTapToPayLinking();
      await AdyenPlugin.initPosSession().catch((error) => {
        console.error('Failed to initialize Adyen POS session', error);
      });
      if (needsTapToPayLinking) {
        await AdyenPlugin.linkTapToPay().catch((error) => {
          console.error('Failed to link tap to pay', error);
        });
      }
      return true;
    } finally {
      adyenPosSessionInit = null;
    }
  })();

  return adyenPosSessionInit;
}

export function useAdyenPaymentMethods() {
  const shouldLoadPaymentMethods = ref(false);

  onMounted(async () => {
    shouldLoadPaymentMethods.value = await ensureAdyenPosSession();
  });

  return useQuery({
    queryKey: ['adyenMethods'],
    queryFn: () => AdyenPlugin.getMethods(),
    enabled: computed(() => shouldLoadPaymentMethods.value),
  });
}
